// src/CategoryForm.js
import React, { useState } from "react";
import { useCheckAccess } from "../../utils/Utilities";
import { createCategoryConfig } from "../../service/UtilApi";

const CategoryForm = () => {
    useCheckAccess('ConfigRW');
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [subcategoryName, setSubcategoryName] = useState("");
    const [subCategoryDescription, setSubCategoryDescription] = useState("");
    const [subcategoryAmount, setSubcategoryAmount] = useState("");
    const [message, setMessage] = useState("");
    const [uniqueOption, setUniqueOption] = useState("");
    const [categoryGroup, setCategoryGroup] = useState("");



    const handleSubmit = async (event) => {
        event.preventDefault();

        const categoryData = {
            name: name.trim(),
            description: description.trim(),
            subcategoryName: subcategoryName.trim(),
            subCategoryDescription: subCategoryDescription.trim(),
            subcategoryAmount: subcategoryAmount.trim(),
            uniqueOption: uniqueOption.trim(),
            categoryGroup: categoryGroup.trim(),
        };

        try {
            // Make API call to create category and subcategory
            const response = await createCategoryConfig(categoryData);
            if (response) {
                window.location.reload();
            }
            setMessage(response.message);
        } catch (error) {
            setMessage("Error: " + error.response?.data?.message || "Something went wrong");
        }
    };

    return (
        <>

            <div className="general_parent">
                <div className="general_container">
                    <div className="general_body">
                        <h2>Create Category and Subcategory</h2>
                        <br />
                        <form onSubmit={handleSubmit}>
                            <div className="auth_element">
                                <label>Category Group:</label>
                                <select
                                    value={categoryGroup}
                                    onChange={(e) => setCategoryGroup(e.target.value)}
                                    required
                                    className="auth_select"
                                >
                                    <option value="" disabled>Select a Category Group</option>
                                    <option value="categories">categories</option>
                                    <option value="expense_categories">expense_categories</option>
                                </select>
                            </div>
                            <div className="auth_element">
                                <label className="auth_element">Category Name:</label>
                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                    className="auth_label"
                                />
                            </div>
                            <div className="auth_element">
                                <label>Category Description:</label>
                                <input
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    required
                                    className="auth_label"
                                />
                            </div>
                            <div className="auth_element">
                                <label>Subcategory Name:</label>
                                <input
                                    type="text"
                                    value={subcategoryName}
                                    onChange={(e) => setSubcategoryName(e.target.value)}
                                    required
                                    className="auth_label"
                                />
                            </div>
                            <div className="auth_element">
                                <label>Subcategory Description:</label>
                                <input
                                    value={subCategoryDescription}
                                    onChange={(e) => setSubCategoryDescription(e.target.value)}
                                    required
                                    className="auth_label"
                                />
                            </div>
                            <div className="auth_element">
                                <label>Subcategory amount:</label>
                                <input
                                    value={subcategoryAmount}
                                    onChange={(e) => setSubcategoryAmount(e.target.value)}

                                    className="auth_label"
                                />
                            </div>
                            <div className="auth_element">
                                <label>Uniqueness Check:</label>
                                <select
                                    value={uniqueOption}
                                    onChange={(e) => setUniqueOption(e.target.value)}

                                    className="auth_select"
                                >
                                    <option value="" disabled>Select a uniqueness rule</option>
                                    <option value="familyId">familyId</option>
                                    <option value="familyId_date">familyId_date</option>
                                </select>
                            </div>
                            <button type="submit">Create</button>
                        </form>
                        {message && <p>{message}</p>}
                    </div>
                </div>
            </div>

        </>
    );
};

export default CategoryForm;
